module.exports = __webpack_public_path__ + "img/monitor.d8486dc1.png";